var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAQklEQVR42mMY5uD///9nQJhszVs2bwZjEJsszT3d3SAMN4QczRiGkKUZ0xDKDUijqQH4MGEDCGCEAXhAGjF4GOUXAATH3Ef+RfYdAAAAAElFTkSuQmCC";
  export default img;